import { supabase } from '../supabase';

export async function adminSetBusDriver(busId, driverId) {
  const { data, error } = await supabase.rpc('admin_set_bus_driver', {
    p_bus_id: busId,
    p_driver_id: driverId || null,
  });
  return { data, error };
}

export async function adminSetBusArea(busId, area) {
  const { data, error } = await supabase.rpc('admin_set_bus_area', {
    p_bus_id: busId,
    p_area: area?.trim() || '',
  });
  return { data, error };
}

export async function adminMovePassengerBus(passengerId, tripDate, busId, assignmentStatus = null) {
  const { data, error } = await supabase.rpc('admin_move_passenger_bus', {
    p_passenger_id: passengerId,
    p_trip_date: tripDate,
    p_bus_id: busId || null,
    p_assignment_status: assignmentStatus,
  });
  return { data, error };
}

export async function adminSetPassengerStatus(passengerId, tripDate, status) {
  const { data, error } = await supabase.rpc('admin_set_passenger_status', {
    p_passenger_id: passengerId,
    p_trip_date: tripDate,
    p_status: status,
  });
  return { data, error };
}

export async function adminRebalanceArea(area, tripDate) {
  const { data, error } = await supabase.rpc('admin_rebalance_area', {
    p_area: area,
    p_trip_date: tripDate,
  });
  return { data, error };
}
